export default __webpack_public_path__ + "static/media/solesta-logo.bc65c0c7.png";